import ReactModal from 'react-modal'
import PropTypes from 'prop-types'

ReactModal.setAppElement('#redfunnel__consumer-booking')

const Modal = ({
  isOpen = false,
  onRequestClose = null,
  children,
  className = '',
  overlayClassName = '',
  whiteBg = false,
}) => (
  <ReactModal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    overlayClassName={`fixed z-[102] inset-0 bg-opacity-50 ${
      whiteBg ? 'bg-white' : ' bg-black'
    } ${overlayClassName}`}
    className={`absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 max-h-[100%] overflow-y-auto ${className}`}
  >
    {children}
  </ReactModal>
)

Modal.defaultProps = {
  isOpen: false,
  onRequestClose: null,
  className: '',
  overlayClassName: '',
  whiteBg: false,
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  whiteBg: PropTypes.bool,
}

export default Modal
